export const getLanguageFromLocal = () => {
  const ln = localStorage.getItem("i18nextLng");
  if (ln) return ln;
  return "en";
};
